// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pawmot: PokeData = {
  "id": 923,
  "name": "pawmot",
  "height": 9,
  "weight": 410,
  "base_experience": 245,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "scratch",
    "slam",
    "bite",
    "growl",
    "thunder-shock",
    "thunder-wave",
    "dig",
    "agility",
    "quick-attack",
    "spark",
    "charge",
    "arm-thrust",
    "close-combat",
    "discharge",
    "entrainment",
    "wild-charge",
    "nuzzle",
    "revival-blessing",
    "double-shock"
  ],
  "moves": [
    "scratch",
    "bite",
    "growl",
    "thunder-shock",
    "quick-attack",
    "close-combat",
    "wild-charge",
    "thunderbolt",
    "bulk-up",
    "electric-terrain",
    "electric-wrath",
    "thunder-punch",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 484,
    "item": null,
    "species": [
      {
        "name": "pawmi",
        "order": 954,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pawmo",
        "order": 955,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 921,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "pawmot",
        "order": 956,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 922,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 146,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
